import { inject, Injectable } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router'
import { BehaviorSubject, Observable, filter } from 'rxjs'
import { BreadcrumbItem } from '../breadcrumb-item/breadcrumb-item.interface'

@Injectable({
    providedIn: 'root',
})
export class BreadcrumbRouterService {
    readonly #router = inject(Router)
    readonly #activatedRoute = inject(ActivatedRoute)

    public outlet = 'primary'

    readonly #breadcrumbsBehaviorSubject: BehaviorSubject<BreadcrumbItem[]> = new BehaviorSubject<BreadcrumbItem[]>(
        new Array<BreadcrumbItem>()
    )
    readonly breadcrumbs$: Observable<BreadcrumbItem[]> = this.#breadcrumbsBehaviorSubject.asObservable()

    constructor() {
        this.#router.events
            .pipe(
                takeUntilDestroyed(),
                filter((event) => event instanceof NavigationEnd)
            )
            .subscribe((event) => {
                const breadcrumbs: any[] = []
                let currentRoute: ActivatedRoute | null = this.#activatedRoute.root
                let url = ''
                do {
                    const childrenRoutes: ActivatedRoute[] = currentRoute.children
                    currentRoute = null
                    childrenRoutes.forEach((childRoute) => {
                        // console.log('breadcrumb event', event, 'route', route);
                        if (childRoute.outlet === this.outlet) {
                            const routeSnapshot = childRoute.snapshot
                            url += '/' + routeSnapshot.url.map((segment) => segment.path).join('/')
                            breadcrumbs.push({
                                label: routeSnapshot.data['title'] ?? routeSnapshot.title ?? '',
                                url,
                                queryParams: routeSnapshot.queryParams,
                            })
                            currentRoute = childRoute
                        }
                    })
                } while (currentRoute)

                this.#breadcrumbsBehaviorSubject.next(Object.assign([], breadcrumbs))

                return breadcrumbs
            })
    }
}
